module.exports = __webpack_public_path__ + "img/home-banner.b1be848.png";